import React from "react";
import { ShieldCheck, MapPin, EyeOff, Flag } from "lucide-react";

export default function Safety() {
  return (
    <div className="pbp-section py-12 md:py-16 max-w-3xl">
      <div className="text-xs uppercase tracking-[0.18em] text-[#86868b] font-semibold">Trust &amp; Safety</div>
      <h1 className="mt-2 text-4xl font-semibold tracking-tighter">Safety guidelines</h1>
      <p className="mt-4 text-[#1d1d1f]/80 leading-relaxed max-w-xl">
        PartByPart connects strangers. Please follow these guidelines to protect yourself.
      </p>
      <div className="mt-10 space-y-4">
        {[
          { i: MapPin, t: "Meet in public", d: "Always meet at a busy, well-lit public location. Avoid private homes for first-time meetings." },
          { i: ShieldCheck, t: "Verify before paying", d: "Power on the device, inspect the part, and confirm the model number on the part itself before any payment." },
          { i: EyeOff, t: "Don't share private info", d: "Never share OTPs, bank credentials, or your Apple ID with another user. PartByPart will never ask for these." },
          { i: Flag, t: "Report suspicious behaviour", d: "Use the Report button on any listing or chat. Three reports auto-suspend a listing pending review." },
        ].map(({ i: Icon, t, d }) => (
          <div key={t} className="pbp-card p-5 flex gap-4">
            <div className="w-10 h-10 rounded-xl bg-[#0071e3]/10 text-[#0071e3] grid place-items-center"><Icon className="w-5 h-5" strokeWidth={1.6} /></div>
            <div>
              <div className="font-semibold">{t}</div>
              <div className="text-sm text-[#86868b]">{d}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
